<template>
    <div>
        <div class="row">
            <div class="col-md-12">
                <div class="card shadow-sm">
                    <div class="card-body">
                        <div v-for="question in questions" class="mb-5">
                            <h5 class="card-title">
                                {{ question.title }}
                            </h5>
                            <div v-html="question.text">

                            </div>
                            <div v-if="question.image_url !== null" class="mt-2">
                                <img :src="question.image_url" :alt="question.title" class="img-fluid" style="max-height: 300px">
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-md-12" v-if="!questions.length">
                <div class="alert alert-secondary border-dark">
                    {{ $t('pages.faq.none') }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { SweetModal } from 'sweet-modal-vue'
import PageHeader from "../../../Includes/PageHeader";
import FaqRepository from "../../../../repositories/FAQ/FaqRepository";
import StaticLoadingIndicatorIcon from "../../../Includes/StaticLoadingIndicatorIcon";
export default {
    name: "FrequentlyAskedQuestions",
    components: {StaticLoadingIndicatorIcon, PageHeader, SweetModal},
    data: () => ({
        questions: [],

        selectedQuestion: null,
    }),
    mounted() {
        this.getLocalizedQuestions();
    },
    methods: {
        getLocalizedQuestions() {
            FaqRepository
                .getLocalizedQuestions()
                .then((res) => this.questions = res.data);
        },
        showQuestionText(question) {
            FaqRepository
                .getSpecificLocalizedQuestion(question.id)
                .then((res) => {
                    this.selectedQuestion = res.data;
                    this.$nextTick(() => this.$refs.expandedQuestionModal.open());
                });
        }
    }
}
</script>

<style scoped>

</style>
